import { BoxDetailTransferProps } from '@/box/interface'
import { TemplateTransferTable } from '@/template/transfer/table'
import React from 'react'

export const BoxDetailTransfer: React.FC<BoxDetailTransferProps> = (
  props: BoxDetailTransferProps
) => {
  const { contactTemplate } = props

  return (
    <div>
      <TemplateTransferTable data={contactTemplate?.transfers} />
    </div>
  )
}
